/**
 * Episode Image Upload API
 *
 * Sends image source URLs to the backend, which downloads and re-uploads
 * them to S3 under a pre-generated episode ID during JSON import.
 * This avoids browser CORS restrictions on the source CDN.
 */

import { apiPost } from 'services/api';

/**
 * Ask the backend to download an image and re-upload it to S3.
 *
 * @param episodeId - Pre-generated UUID for the episode
 * @param assetType - "thumbnail" | "background" | "persona_0".."persona_4"
 * @param sourceUrl - URL of the image to download and re-upload
 * @returns CDN URL of the uploaded asset
 */
export async function uploadEpisodeAsset(
  episodeId: string,
  assetType: string,
  sourceUrl: string
): Promise<string> {
  const data = await apiPost<{ url: string }>('/api/admin/episodes/upload-asset', {
    episode_id: episodeId,
    asset_type: assetType,
    source_url: sourceUrl,
  });

  return data.url;
}
